module.exports = __webpack_public_path__ + "static/media/monitoring5.e7a2b035.png";